<template>
  <div class="notice-content">
    <h2 class="h2-title">{{details.title}}</h2>
    <p class="notice-text">{{details.content}}</p>
  </div>
</template>
<script>
import { getStaNoticeDetails } from "@/common/api/index";
export default {
  name: 'notice-content',
  data(){
    return{
      details: {}
    }
  },
  mounted() {
    this.getStaNoticeDetails();
  },
  methods: {
    getStaNoticeDetails(){
      getStaNoticeDetails({noticePkId: this.$route.query.id})
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            this.details = data.data[0];
          }
        })
    },
  }
}
</script>
<style lang="less">
  .notice-content{
    padding: 0.2rem;
    .h2-title{
      font-size: 0.32rem;
      text-align: center;
    }
    .notice-text{
      font-size: 0.28rem;
      line-height: 0.46rem;
      text-indent: 2em;
      margin-top: 0.4rem;
    }
  }
</style>